interface ProductGradeBadgeProps {
  grade: 'A' | 'B' | 'C' | 'D';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const gradeConfig = {
  A: {
    label: 'A',
    bgColor: 'bg-emerald-50 dark:bg-emerald-950/30',
    textColor: 'text-emerald-600 dark:text-emerald-400',
    borderColor: 'border-emerald-200 dark:border-emerald-800',
    description: 'דירוג A - מוצר פרימיום איכותי במצב מושלם'
  },
  B: {
    label: 'B',
    bgColor: 'bg-blue-50 dark:bg-blue-950/30',
    textColor: 'text-blue-600 dark:text-blue-400',
    borderColor: 'border-blue-200 dark:border-blue-800',
    description: 'דירוג B - מוצר סטנדרט במצב טוב'
  },
  C: {
    label: 'C',
    bgColor: 'bg-amber-50 dark:bg-amber-950/30',
    textColor: 'text-amber-600 dark:text-amber-400',
    borderColor: 'border-amber-200 dark:border-amber-800',
    description: 'דירוג C - נמכר כפי שהוא, ללא החזרה'
  },
  D: {
    label: 'D',
    bgColor: 'bg-rose-50 dark:bg-rose-950/30',
    textColor: 'text-rose-600 dark:text-rose-400',
    borderColor: 'border-rose-200 dark:border-rose-800',
    description: 'דירוג D - מכירה סופית, ללא החזרה'
  }
};

const sizeClasses = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-7 h-7 text-sm',
  lg: 'w-8 h-8 text-base'
};

const ProductGradeBadge = ({ grade, className = '', size = 'md' }: ProductGradeBadgeProps) => {
  const config = gradeConfig[grade];

  return (
    <div
      className={`
        inline-flex items-center justify-center
        ${sizeClasses[size]}
        ${config.bgColor}
        ${config.textColor}
        ${config.borderColor}
        border
        rounded-md
        font-semibold
        ${className}
      `}
      title={config.description}
    >
      {config.label}
    </div>
  );
};

export default ProductGradeBadge;